import React, { useState, useRef } from 'react';
import styled from 'styled-components';

import css from 'css';

import Html from 'partials/Html';

import useOnClickOutside from 'hooks/useOnClickOutside';

const Wrapper = styled.div``;

const ToolTipTitle = styled.div`
    width: max-content;
    z-index: 1;
    cursor: pointer;
    color: ${css.colors.blue};
    font-size: 0.8em;
`;

const ToolTipText = styled.div`
    visibility: visible;
    width: 200px;
    background-color: #E4EFFD;
    box-shadow: 0px 3px 16px -3px ${css.colors.black};
    color: #032956;
    border-radius: 20px;
    line-height: 1.5;
    padding: 10px;
    position: absolute;
    z-index: 1;
    bottom: 45px;
    left: 30px;
    margin-left: -60px;
    font-size: 0.8em;

    &:after {
        content: "";
        position: absolute;
        top: 100%;
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent #E4EFFD transparent;
        transform: rotate(180deg);
    }

    svg {
        position: relative !important;
        display: block;
        opacity: 1 !important;
        top: 0 !important;
        left: 5px;
        margin-bottom: 10px;
    }

    a {
        text-decoration: underline;
        cursor: pointer;
    }
`;

function Tooltip({ title, content }) {
    const [open, setOpen] = useState(false);
    const toolTipRef = useRef();

    useOnClickOutside(toolTipRef, () => setOpen(false));

    return (
        <Wrapper onClick={() => setOpen(!open)} innerRef={toolTipRef}>
            <ToolTipTitle> {title} </ToolTipTitle>
            { open &&
                <ToolTipText>
                    <Html content>{content}</Html>
                </ToolTipText>
            }
        </Wrapper>
    )
}

export default Tooltip;


// WEBPACK FOOTER //
// ./src/partials/Tooltip.js